"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("@influitive/secret-garden/lib/button"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Action =
/*#__PURE__*/
(0, _styled.default)(_button.default, {
  target: "elblljk0"
})("margin-left:", (0, _styledSystem.themeGet)('spacing.1'), "px;");
var Actions =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "elblljk1"
})("display:flex;flex-direction:row-reverse;padding-top:", (0, _styledSystem.themeGet)('spacing.2'), "px;");

var Footer =
/*#__PURE__*/
function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Footer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_message", function () {
      if (_this.props.disableMessage) return null;
      return _react.default.createElement(Action, {
        className: "c-action c-message",
        href: _this.props.messageUrl
      }, _this.props.t('Message'));
    });

    _defineProperty(_assertThisInitialized(_this), "_viewProfile", function () {
      if (_this.props.disableViewProfile) return null;
      return _react.default.createElement(Action, {
        className: "c-action c-view-profile",
        href: "/profiles/".concat(_this.props.id)
      }, _this.props.t('View Profile'));
    });

    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      if (this.props.disableMessage && this.props.disableViewProfile) return null;
      return _react.default.createElement(Actions, {
        className: "c-actions"
      }, this._message(), this._viewProfile());
    }
  }]);

  return Footer;
}(_react.Component);

_defineProperty(Footer, "propsTypes", {
  id: _propTypes.default.string.isRequired,
  disableViewProfile: _propTypes.default.bool.isRequired,
  disableMessage: _propTypes.default.bool.isRequired,
  messageUrl: _propTypes.default.string.isRequired
});

var _default = (0, _reactI18next.withNamespaces)()(Footer);

exports.default = _default;